// extracted by mini-css-extract-plugin
export default {"DimensionsFeature":"wc_a bhr_b bhr_we"};